<template>
  <b-popover
    id="filtroPopover"
    ref="popover"
    target="popover-filtro"
    triggers="click"
    :show.sync="popoverShow"
    placement="bottom"
    custom-class="multiselect-popover-filtro-adicional"
  >
    <div
      slot="title"
      style="text-align: center;"
    >
      <span
        style="vertical-align: sub;padding-right: 6px;"
      >Filtros</span>
      <i
        v-b-tooltip.hover
        title="Os filtros aplicados nessa tela são gravados por usuário e serão apresentados como padrão ao acessar o painel de propostas!"
        style="font-size: 0.8rem;"
      >
        <font-awesome-icon
          :icon="faQuestionCircle"
        />
      </i>
      <b-button
        variant="none"
        class="close"
        @click="onClose"
      >
        <span aria-hidden="true">&times;</span>
      </b-button>
    </div>
    <!-- Foi pedido para esconder o campo -->
    <!-- <b-form-group
      label="Palavra chave"
    >
      <b-form-input
        v-model="value.palavraChave"
      />
    </b-form-group> -->
    <div class="w-100 mb-50">
      <legend class="col-form-label pt-0">
        Validade da proposta
      </legend>
      <de-para
        ref="dataValidade"
        v-model="value.validade"
      />
    </div>
    <pessoa-multiselect
      ref="filtroPessoa"
      v-model="value.pessoas"
    />
    <empresa-multiselect
      v-model="value.empresas"
      :label="'Empresa Contratante'"
      :painel-proposta="true"
      class="mb-1"
    />
    <proposta-multiselect
      ref="filtroProposta"
      v-model="value.numeroProposta"
      :filtro-adicional="filtroPropostaNumero"
    />
    <div
      style="margin-top: 6px;
      margin-bottom: 20px;"
    >
      Status
      <v-select
        v-model="value.statusProposta"
        label="nome"
        :options="itensStatus"
        :reduce="map => map.tipo"
        multiple
      />
    </div>
    <etiqueta-select
      v-model="value.etiquetas"
      :multiple="true"
    />
    <div
      style="margin-top: 6px;
      margin-bottom: 20px;"
    >
      Status integração Omie
      <v-select
        v-model="value.statusOmie"
        label="nome"
        :options="[{ tipo: 1, nome:'Pendente'}, { tipo: 3, nome: 'Erro'},{ tipo: 2, nome: 'Sucesso'}]"
        :reduce="map => map.tipo"
        multiple
      />
    </div>
    <div
      style="margin-top: 6px;
      margin-bottom: 20px;"
    >
      Pessoa Como Chegou
      <v-select
        v-model="value.PessoasComoChegou"
        label="nome"
        :options="pessoasIndicacaoOptions"
        :reduce="map => map.tipo"
        multiple
        @input="onPessoasIndicacaoChange"
      />
    </div>
    <div
      v-if="showPessoaSelect"
      style="margin-top: 6px;
      margin-bottom: 20px;"
    >
      <indicacao-select
        label="Selecionar Pessoa que indicou"
        v-model="value.pessoaQueIndicou"
        :disabled="false"
      />
    </div>
    <departamento-select
      v-model="value.departamento"
      :label="'Departamento'"
      class="mb-1" />

    <b-row>
      <b-form-group class="col-6">
        <b-form-checkbox
          v-model="value.geraContrato"
          :value="true"
          :unchecked-value="null"
        >
          Gera contrato
        </b-form-checkbox>
      </b-form-group>
      <b-form-group class="col-6">
        <b-form-checkbox
          v-model="value.geraContrato"
          :value="false"
          :unchecked-value="null"
        >
          Não gera contrato
        </b-form-checkbox>
      </b-form-group>
    </b-row>
    <b-row>
      <b-form-group class="col-6">
        <b-form-checkbox
          v-model="value.checklist"
          :value="true"
          :unchecked-value="null"
        >
          Com Checklist
        </b-form-checkbox>
      </b-form-group>
      <b-form-group class="col-6">
        <b-form-checkbox
          v-model="value.checklist"
          :value="false"
          :unchecked-value="null"
        >
          Sem Checklist
        </b-form-checkbox>
      </b-form-group>
    </b-row>
  </b-popover>
</template>

<style lang="scss">
.multiselect-popover-filtro-adicional {
  max-width: 420px;
}

.multiselect-popover-filtro-adicional .arrow {
  visibility: hidden;
}

.multiselect-popover-filtro-adicional .popover-body {
  //max-height: //610px;//310px;
  max-height: calc(70vh - 132px);
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #f5f5f5;
      }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bfbfbf;
    }
}
</style>

<script>
import vSelect from 'vue-select'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'FiltroAdicional',
  components: {
    DePara: () => import('@/shared/components/de-para/DePara.vue'),
    PessoaMultiselect: () => import('@/shared/components/pessoa-multiselect/PessoaMultiselect.vue'),
    PropostaMultiselect: () => import('@/shared/components/proposta-multiselect/PropostaMultiselect.vue'),
    // StatusSelect: () => import('@/shared/components/status-select/StatusSelect.vue'),
    EtiquetaSelect: () => import('@/app-modulo/comercial/proposta/shared/components/etiqueta-select/EtiquetaSelect.vue'),
    EmpresaMultiselect: () => import('@/shared/components/empresa-multiselect/EmpresaMultiselect.vue'),
    IndicacaoSelect: () => import('@/shared/components/indicacao-select/IndicacaoSelect.vue'),
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    vSelect,
    FontAwesomeIcon,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      faQuestionCircle,
      status: [],
      popoverShow: false,
      itensStatus: [{ tipo: 6, nome: 'Checklist' },
        { tipo: 1, nome: 'Pendente envio' },
        { tipo: 2, nome: 'Negociação' },
        { tipo: 7, nome: 'Não aprovada' },
        { tipo: 3, nome: 'Aprovada' },
        { tipo: 8, nome: 'Finalizada' },
        { tipo: 4, nome: 'Rejeitada' },
        { tipo: 5, nome: 'Expirada' }],
      pessoasIndicacaoOptions: [
        { tipo: 0, nome: 'Indicação' },
        { tipo: 1, nome: 'Facebook' },
        { tipo: 2, nome: 'Instagram' },
        { tipo: 3, nome: 'Google' },
        { tipo: 4, nome: 'Outros' },
      ],
      showPessoaSelect: false,
    }
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
    filtroPropostaNumero(propostas) {
      let propostasFilt = []
      propostasFilt = propostas.filter(fil => fil.numeroProposta && fil.numeroProposta !== '')
      return propostasFilt
    },
    onPessoasIndicacaoChange(selected) {
      if (selected.includes(0)) {
        this.value.PessoasComoChegou = [0] // Restrict to only 'Indicação'
        this.showPessoaSelect = true // Show Pessoa selection field
      } else {
        this.value.PessoasComoChegou = selected // Update PessoasComoChegou with the selected values
        this.showPessoaSelect = false // Hide Pessoa selection field
      }
    },
    prepareRequestData() {
      const requestData = { ...this.value } // Clone the value object to avoid direct mutation
      if (requestData.pessoaQueIndicou) {
        requestData.pessoaQueIndicou = requestData.pessoaQueIndicou.id // Send only the ID of the selected person
      }
      return requestData // Return the prepared data for the API
    },
  },
}
</script>
